import type { ParamMatcher } from '@sveltejs/kit';

export const match: ParamMatcher = (param) => {
    //console.log("Testing", param, /^[a-zA-Z_].[a-zA-Z0-9_]{1,50}$/.test(param))
    return /^[a-zA-Z_].[a-zA-Z0-9_]{1,50}$/.test(param);
};